import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Aircraftwatch, FlightWatchModelResponse } from 'src/app/models/flight-watch';
import { FlightWatchApiService } from './flight-watch-api.service';

@Injectable({
  providedIn: 'root'
})
export class FlightWatchMapSharedService {
    constructor(private flightWatchApiService: FlightWatchApiService) { }

    private aircraftDetailsSubject = new Subject<FlightWatchModelResponse>();
    aicraftDetails$ = this.aircraftDetailsSubject.asObservable();

    private lodingspinnerSubject = new Subject<boolean>();
    lodingspinner$ = this.lodingspinnerSubject.asObservable();

    private aicraftCompanyAssignSubject = new Subject<Aircraftwatch>();
    aicraftCompanyAssign$ = this.aicraftCompanyAssignSubject.asObservable();

    openLoadingSpinner() {
        this.lodingspinnerSubject.next(true);
    }
    closeLoadingSpinner() {
        this.lodingspinnerSubject.next(false);
    }
    async getAndUpdateAircraftWithHistorical(fboId: number, icao: string, tailNumber: string, notifyEvent: boolean = true) : Promise<void> {
        this.openLoadingSpinner();
        this.flightWatchApiService.getAircarftLiveDataHistorical(fboId, icao, tailNumber).subscribe(response => {
            if(notifyEvent)
                this.aircraftDetailsSubject.next(response);
            this.closeLoadingSpinner();
            return response;
        });
    }
    
    updateCustomerAicraftData(data: any) : void{
        this.aicraftCompanyAssignSubject.next(data);
    }
}
